import React from 'react';
import { Tag, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { format } from 'date-fns';

const dateFieldLabels = {
  'createdAt': 'Criado em',
  'lastSale': 'Última venda',
  'birthDate': 'Data de nascimento'
};

const getFilterLabel = (filter) => {
  const fieldLabel = dateFieldLabels[filter.field] || filter.field;
  
  // Verificar primeiro se é um filtro de data específica (filterType ou type)
  const filterType = filter.filterType || filter.type;
  
  if (filterType === 'specific_date' && filter.startDate) {
    // Para data específica, usar apenas startDate e evitar problemas de timezone
    const date = new Date(filter.startDate + 'T12:00:00'); // Adicionar meio-dia para evitar problemas de timezone
    const formattedDate = format(date, 'dd/MM/yyyy');
    return `${fieldLabel}: ${formattedDate}`;
  } else if (filterType === 'specific_month' && filter.month) {
    const months = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
    const monthLabel = months[filter.month - 1];
    return filter.year ? `${fieldLabel}: ${monthLabel}/${filter.year}` : `${fieldLabel}: ${monthLabel} (todos os anos)`;
  } else if (filterType === 'specific_year') {
    return `${fieldLabel}: ${filter.year}`;
  } else if (filterType === 'range' && filter.startDate && filter.endDate) {
    // Para ranges, mostrar as duas datas
    const startDate = new Date(filter.startDate + 'T12:00:00');
    const endDate = new Date(filter.endDate + 'T12:00:00');
    const formattedStartDate = format(startDate, 'dd/MM/yyyy');
    const formattedEndDate = format(endDate, 'dd/MM/yyyy');
    return `${fieldLabel}: ${formattedStartDate} - ${formattedEndDate}`;
  } else if (filter.startDate && filter.endDate) {
    // Fallback para filtros sem tipo específico
    const startDate = new Date(filter.startDate + 'T12:00:00');
    const endDate = new Date(filter.endDate + 'T12:00:00');
    const formattedStartDate = format(startDate, 'dd/MM/yyyy');
    const formattedEndDate = format(endDate, 'dd/MM/yyyy');
    return `${fieldLabel}: ${formattedStartDate} - ${formattedEndDate}`;
  } else {
    return `${fieldLabel}: filtro aplicado`;
  }
};

const ActiveFilters = ({ filters, onRemoveFilter, onClearAll, filterType = 'date' }) => {
  if (!filters || filters.length === 0) {
    return null;
  }

  const getFilterTypeLabel = () => {
    switch (filterType) {
      case 'advanced':
        return 'Filtros ativos(avançados):';
      case 'date':
      default:
        return 'Filtros ativos(por data):';
    }
  };

  return (
    <div style={{ marginBottom: 16 }}>
      <Space wrap>
        <span style={{ fontWeight: 'bold', color: '#666' }}>{getFilterTypeLabel()}</span>
        {filters.map((filter, index) => (
          <Tag
            key={index}
            closable
            onClose={() => onRemoveFilter(index)}
            color="blue"
            style={{ marginBottom: 4 }}
          >
            {getFilterLabel(filter)}
          </Tag>
        ))}
        {filters.length > 1 && (
          <Tag
            color="red"
            style={{ cursor: 'pointer', marginBottom: 4 }}
            onClick={onClearAll}
          >
            <CloseOutlined /> Limpar todos
          </Tag>
        )}
      </Space>
    </div>
  );
};

export default ActiveFilters;